<div class="container-fluid" >
  <div class="row">
    <div class="col-md-12 header" style="position:relative">
      <h4><b>{{ 'common.dashboard' | translate }}</b></h4>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h4>{{ 'pages.barcodePage.qrCodeConfirmation' | translate }}</h4>
      <h5 class="subtitle" *ngIf="!ShowNotfound">{{ 'pages.barcodePage.qrCodeSuggestion' | translate }}</h5>
      <div class="row">
        <div class="col-md-12 barcode-section" style="min-height:300px;">
          <div class="col-md-4 col-md-offset-4" style="text-align:center">
            <img *ngIf="DeliveryCode == '' && !ShowNotfound " src="../../assets/img/red-loader.gif" class="img-responsive" style="margin: 0 auto" />
            <qrcode [qrdata]="DeliveryCode" *ngIf="DeliveryCode != ''"  [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
            <div style="min-height:300px;padding-top: 125px;" *ngIf="ShowNotfound"> <span class="armx-icon armx-barcode"></span>{{ 'pages.barcodePage.showNotfoundMsg' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h1>{{ 'pages.barcodePage.howToUse' | translate }}</h1>
    </div>
    <div class="col-md-4 box">
      <div class="circle">{{ 'common.1' | translate }}</div>
      <img src="../../assets/img/qrBlack.png" />
      <h4>{{ 'pages.barcodePage.openQRCode' | translate }}</h4>
    </div>
    <div class="col-md-4 box">
      <div class="circle">{{ 'common.2' | translate }}</div>
      <img src="../../assets/img/handHoldsQr.svg" />
      <h4>{{ 'pages.barcodePage.scanQRCode' | translate }}</h4>
    </div>
    <div class="col-md-4 box">
      <div class="circle">{{ 'common.3' | translate }}</div>
      <img src="../../assets/img/qrTranspant.png" />
      <h4>{{ 'pages.barcodePage.confirmQRCode' | translate }}</h4>
    </div>
  </div>
</div>
